import * as angular from "angular";
import { IVehicle } from "@interfaces/IVehicle";
import "./vehicleInputEditor.scss";
import { IVehicleInput } from "@interfaces/IVehicleInput";
import { TranslationService } from "@services/translation.service";
import { IInputType } from "@interfaces/IInputType";
import { InputTypeService } from "@services/inputType.service";

interface IComponentBindings {
    vehicle: IVehicle;
    inputTypes: IInputType[];
}

export class ComponentController implements angular.IComponentController, IComponentBindings {

    vehicle: IVehicle;
    inputTypes: IInputType[];

    onInputsValid: (args: { message: string }) => void;

    errorMessage: string;

    static $inject = ["translationService", "$mdDialog", "inputTypeService"];

    constructor(
        private readonly translationService: TranslationService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly inputTypeService: InputTypeService
    ) {}

    $onInit(): void {
        this.inputTypeService.getInputTypes().then((inputTypes) => (this.inputTypes = inputTypes));
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["vehicle"]) {
            this.checkNameValidity();
        }
    }

    onModelUpdated(currentIndex: number, input: IVehicleInput) {

        const selectedInputType = this.inputTypes.find((inputType) => inputType.Id == input.InputTypeId);

        input.InputStateDescription = selectedInputType.InputStateDescription;

        this.checkNameValidity(currentIndex);
    }

    //-----------------

    private checkNameValidity(currentIndex?: number) {
        this.errorMessage = '';

        this.vehicle?.Inputs.forEach(input => {
            if (!input.InputTypeId) {
                this.errorMessage = this.translationService.t('vehicleInputEditor.inputNameRequired');
            }
        });

        if (this.onInputsValid) {
            this.onInputsValid({ message: this.errorMessage });
        }
    }

    openEditInputTypesDialog($event: MouseEvent) {

        const controller = ($mdDialog) => {
            return {
                hide: () => { $mdDialog.hide(); },
            }
        };

        controller.$inject = ["$mdDialog"];

        const dialogOptions: angular.material.IDialogOptions = {
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: true,
            template: require("./vehicleInputTypeManager/vehicleInputTypeManager.dialog.html"), // Use scope
            controller: controller,
            controllerAs: "$ctrl"
        };

        this.$mdDialog.show(dialogOptions).then((dopt) => {
            console.log(dopt);
            this.inputTypeService.getInputTypes().then((inputTypes) => (this.inputTypes = inputTypes));
        });
    }

}

export class VehicleInputEditorComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            vehicle: "<",
            onInputsValid: "&",
        };

        this.controller = ComponentController;
        this.template = require("./vehicleInputEditor.html");
    }
}
